export const Separator = () => <div className="border-primary my-2 border-l" />;
